import { render, staticRenderFns } from "./bnc_en_linea.vue?vue&type=template&id=1f2eb8e7&scoped=true"
import script from "./bnc_en_linea.vue?vue&type=script&lang=js"
export * from "./bnc_en_linea.vue?vue&type=script&lang=js"
import style0 from "./bnc_en_linea.vue?vue&type=style&index=0&id=1f2eb8e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2eb8e7",
  null
  
)

export default component.exports